// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCriteria from '../../../shared/components/labeled-criteria';
import ReportCriteriaFooter from '../../shared/components/report-criteria-footer';

const UpdateMachineStatusHistoryCriteria = props =>
    <div className='update-machine-status-history-criteria'>
        <div className='criteria'>
            <LabeledCriteria
                className='history-to-display-criteria'
                isRequired={true}
                label='HISTORY_TO_DISPLAY'
                max='999'
                min='1'
                onInputChange={props.onHistoryToDisplayInputChange}
                placeholder='ENTER_A_NUMBER_BETWEEN_0_AND_1000'
                type='number'
                value={props.historyToDisplay}
            />
        </div>
        <ReportCriteriaFooter
            canExport={props.canExport}
            canRunReport={props.canRunReport}
            isRequired={true}
            onCriteriaReset={props.onCriteriaReset}
            onDownloadToExcel={props.onExportToCsv}
            onRunReport={props.onCreateReport}
            showExport={true}
            showReport={true}
        />
    </div>;

UpdateMachineStatusHistoryCriteria.displayName = 'UpdateMachineStatusHistoryCriteria';
UpdateMachineStatusHistoryCriteria.propTypes = {
    canExport: PropTypes.bool.isRequired,
    canRunReport: PropTypes.bool.isRequired,
    historyToDisplay: PropTypes.number,
    onCreateReport: PropTypes.func.isRequired,
    onCriteriaReset: PropTypes.func.isRequired,
    onExportToCsv: PropTypes.func.isRequired,
    onHistoryToDisplayInputChange: PropTypes.func.isRequired
};

export default UpdateMachineStatusHistoryCriteria;



// WEBPACK FOOTER //
// ./src/reports/update-machine-status-history/components/update-machine-status-history-report-criteria.js